import * as Yup from 'yup';

const maxError = 'Max 128 characters only';

const vinValidationSchema = Yup.string()
  .nullable()
  .matches(/^[A-HJ-NPR-Z0-9]*$/, 'Please enter a valid VIN.')
  .test('length', 'VIN must be at least 17 characters', value => value?.length === 17); 

export const assetValidationSchema = Yup.object().shape({
  assetType: Yup.string().required(),
  vin: vinValidationSchema,
  year: Yup.number(),
  make: Yup.string(),
  model: Yup.string(),
  kbbTrim: Yup.string().max(128, maxError),
  nadaTrim: Yup.string().max(128, maxError),
  color: Yup.string().nullable().max(128, maxError),
  isAssetOwner: Yup.string().nullable(),

  assetLienHolder: Yup.object().shape({
    lienHolderId: Yup.string().nullable().max(128, maxError),
    accountNumber: Yup.string().nullable().max(128, maxError),
    phoneNumber: Yup.string().nullable().phone(),
    loan: Yup.object().shape({
      term: Yup.number().nullable(),
    }),

    address: Yup.object().shape({
      streetLine1: Yup.string().nullable().max(128, maxError),
      streetLine2: Yup.string().nullable().max(128, maxError),
      city: Yup.string().nullable().max(128, maxError),
      state: Yup.string().nullable().max(128, maxError),
      zip: Yup.string().nullable().zipCode().max(12, maxError),
    }),
  }),

  assetInsurance: Yup.object().shape({
    company: Yup.string().nullable().max(128, maxError),
    policyNumber: Yup.string().nullable().max(128, maxError),
  }),

  assetRegistration: Yup.object().shape({
    primaryOwner: Yup.string().required('Owner 1 is required').max(128, maxError),
    secondaryOwner: Yup.string().nullable().max(128, maxError),
    plateNumber: Yup.string().nullable().alphaNumeric(),
    state: Yup.string().nullable(),
  }),
  assetValidations: Yup.object().shape({
    isLiftKit: Yup.string().nullable(),
    isSixInchLiftKit: Yup.string().nullable(),
    isHEV: Yup.string().nullable(),
    doesOversizeUndersizeTire: Yup.string().nullable(),
  }),
});

export const plateToVinValidationSchema = Yup.object().shape({
  plateNumber: Yup.string().nullable().required().alphaNumeric(),
  plateState: Yup.string().nullable().required(),
});
